const ZERO_WIDTH_JOINER = 0x200d;
const INVISIBLE = /[\p{Cf}\p{Cc}]/u;
const BLANK = /\p{White_Space}/u;
const MARK = /[\p{Mn}\p{Me}]/u;

const isSkinTone = (cp: number) => cp >= 0x1f3fb && cp <= 0x1f3ff;
const isRegionalIndicator = (cp: number) => cp >= 0x1f1e6 && cp <= 0x1f1ff;
const BLANK_RENDERING_CHARACTERS = new Set([0x115f, 0x1160, 0x3164, 0xffa0, 0x2800, 0xfffc]);
const isTagCharacter = (cp: number) => cp >= 0xe0000 && cp <= 0xe007f;
const isUnassignedSpecial = (cp: number) => cp >= 0xfff0 && cp <= 0xfff8;
const isInvisible = (c: string) => {
  const cp = c.codePointAt(0) ?? 0;
  return INVISIBLE.test(c) || BLANK_RENDERING_CHARACTERS.has(cp) || isTagCharacter(cp) || isUnassignedSpecial(cp);
};

export const visibleLength = (text: string | null | undefined): number => {
  const chars = Array.from(text ?? "");
  const shown = (c: string) => !BLANK.test(c) && !isInvisible(c);
  const first = chars.findIndex(shown);
  if (first < 0) return 0;
  const last = chars.length - 1 - [...chars].reverse().findIndex(shown);

  let count = 0;
  let joinsPrevious = false;
  let halfFlag = false;
  for (const c of chars.slice(first, last + 1)) {
    const cp = c.codePointAt(0) ?? 0;
    if (cp === ZERO_WIDTH_JOINER) joinsPrevious = true;
    else if (isInvisible(c) || MARK.test(c) || isSkinTone(cp)) continue;
    else if (joinsPrevious) joinsPrevious = false;
    else if (isRegionalIndicator(cp)) {
      if (!halfFlag) count++;
      halfFlag = !halfFlag;
    } else {
      halfFlag = false;
      count++;
    }
  }
  return count;
};
